import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

//redux
import { useSelector } from 'react-redux';

//import drawer
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';

//Import Icons
import Icon from '@ailibs/feather-react-ts';
import Soporte from '../../assets/images/brands/Soporte.png';
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from 'reactstrap';

//import images
import { IProgressBar } from '../Common/iComponents/iProgress-bar/iProgress-bar';
import './header-kit.scss';

// Banner de Advertising (Company Settings): un valor vacío, "undefined" o "null" es "sin banner".
const valorBanner = (v: any) => {
  const t = v == null ? '' : String(v).trim();
  return t && t !== 'undefined' && t !== 'null' ? t : '';
};

const Header = (props: any) => {
  const {
    layoutMode,
    isLoadingComodity,
    isLoadingClients,
    isLoadingPurchaseOrders,
    isLoadingwarehouseReceipts,
    isLoadingsalesOrders,
    isLoadingcargoRelease,
    isLoadingPermissions,
    isLoadingEntities,
    isLoadingUser,
    isLoadingApiList,
    isLoadingTasks,
    isLoadingConfigTasks,
    isLoadingRoles,
    isLoadingTraceabilities,
    titleBanner
  } = useSelector((state: any) => ({
    layoutMode: state.Layout.layoutMode,
    isLoadingComodity: state.Commodity.isLoading,
    isLoadingClients: state.clients.isLoading,
    isLoadingPurchaseOrders: state.purchaseOrders.isLoading,
    isLoadingwarehouseReceipts: state.warehouseReceipts.isLoading,
    isLoadingsalesOrders: state.salesOrders.isLoading,
    isLoadingcargoRelease: state.cargoRelease.isLoading,
    isLoadingPermissions: state.Permissions.isLoading,
    isLoadingEntities: state.Entities.isLoading,
    isLoadingUser: state.Users.loading,
    isLoadingApiList: state.ApiList.isLoading,
    isLoadingTasks: state.Tasks.isLoading,
    isLoadingConfigTasks: state.ConfigTasks.isLoading,
    isLoadingRoles: state.Roles.isLoading,
    isLoadingTraceabilities: state.Traceabilities.loading,
    titleBanner: state.Layout.titleBanner
  }));

  const brand = JSON.parse(localStorage.getItem('brand') || '');

  const [search, setsearch] = useState<boolean>(false);
  const [socialDrp, setsocialDrp] = useState<boolean>(false);
  const [isClick, setClick] = useState<boolean>(() => {
    const toggleMenu = localStorage.getItem('toggleMenu');
    return toggleMenu !== null && toggleMenu !== undefined ? JSON.parse(toggleMenu) : false;
  });
  const [position, setPosition] = useState<string>();
  const [open, setOpen] = useState<boolean>(false);
  const [LoadingHeader, setLoadingHeader] = useState(false);
  const [primaryColor, setPrimaryColor] = useState('');
  const [rol, setRol] = useState(0);
  const [Banner, setBanner] = useState({
    urlImage: "",
    urlLink: "",
  });
  // Si la imagen no carga, no se pinta (antes quedaba el ícono de imagen rota).
  const [bannerRoto, setBannerRoto] = useState(false);
  /**
   * Rightsidebar drawer
   */
  const toggleTopDrawer = () => {
    setPosition('right');
    setOpen(!open);
  };

  const onDrawerClose = () => {
    setOpen(false);
  };

  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    setClick(!isClick);
    setToggleMenu(!isClick);
  }

  const setToggleMenu = (isToggle: boolean) => {
    const body = document.body;
    if (isToggle) {
      body.classList.add('sidebar-enable');
      body.setAttribute('data-sidebar-size', 'sm');
    } else {
      body.classList.remove('sidebar-enable');
      body.setAttribute('data-sidebar-size', 'lg');
    }
    localStorage.setItem('toggleMenu', JSON.stringify(isToggle));
  };

  useEffect(() => {
    if (
      isLoadingComodity ||
      (isLoadingClients &&
        isLoadingPermissions != true &&
        isLoadingUser != true &&
        isLoadingApiList != true &&
        isLoadingTasks != true &&
        isLoadingConfigTasks != true) ||
      isLoadingPurchaseOrders ||
      isLoadingwarehouseReceipts ||
      isLoadingsalesOrders ||
      isLoadingcargoRelease ||
      isLoadingPermissions ||
      isLoadingEntities ||
      isLoadingUser ||
      isLoadingApiList ||
      (isLoadingTasks && isLoadingConfigTasks != true) ||
      isLoadingConfigTasks ||
      isLoadingRoles ||
      isLoadingTraceabilities
    ) {
      setLoadingHeader(true);
    } else {
      setLoadingHeader(false);
    }
  }, [
    isLoadingComodity,
    isLoadingClients,
    isLoadingPurchaseOrders,
    isLoadingwarehouseReceipts,
    isLoadingsalesOrders,
    isLoadingcargoRelease,
    isLoadingPermissions,
    isLoadingEntities,
    isLoadingUser,
    isLoadingApiList,
    isLoadingTasks,
    isLoadingConfigTasks,
    isLoadingRoles,
    isLoadingTraceabilities,
  ]);

  useEffect(() => {
    const brand: any = localStorage.getItem('brand');
    const authUser: any = localStorage.getItem('authUser');
    const UserLocal = JSON.parse(authUser);
    const newBrand = JSON.parse(brand);
    setPrimaryColor(newBrand.theme.primaryColor);
    setRol(UserLocal.ROL_ID)
    setBanner({
      urlImage: valorBanner(newBrand.urlImgBanner),
      urlLink: valorBanner(newBrand.urlLinkBanner),
    })
  }, []);

  const hayBanner = !!(Banner.urlImage && Banner.urlLink) && !bannerRoto && (rol == 19 || rol == 22);
  const imagenBanner = (
    <a href={Banner.urlLink} target="_blank" rel="noopener noreferrer">
      <img className=' mw-100 mh-100' src={Banner.urlImage} alt="" onError={() => setBannerRoto(true)} />
    </a>
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isClick) setToggleMenu(isClick);
    }, 10);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-head-sidebar">
              <div className="navbar-brand-box">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img
                      src={brand.small_logo}
                      alt=""
                      height="24"
                      style={{ maxWidth: 50 }}
                    />{' '}
                  </span>
                  <span className="logo-lg">
                    <img src={brand.logo} alt="" style={{ minWidth: "45px", width: "45%", maxHeight: "55px" }} />
                  </span>
                </Link>

                <Link to="/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={brand.small_logo}
                      alt=""
                      height="24"
                      style={{ maxWidth: 50 }}
                    />
                  </span>
                  <span className="logo-lg">
                    <img src={brand.logo} alt="" style={{ minWidth: "45px", width: "45%", maxHeight: "55px" }} />{' '}
                  </span>
                </Link>
              </div>

              <button
                onClick={() => {
                  tToggle();
                }}
                type="button"
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
              >
                <i className="fa fa-fw fa-bars"></i>
              </button>


              {/* <form className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                  />
                  <button className="btn btn-primary" type="button">
                    <i className="bx bx-search-alt align-middle"></i>
                  </button>
                </div>
              </form> */}
            </div>

            {/* En las páginas del kit nuevo el título ya está en la página: aquí va el banner (header-kit.scss). */}
            <div style={{ marginLeft: `${isClick ? "120" : "255"}px` }} className='ContainerTitlerHeader header-item'>
              <span className='ih-top-titulo'>{titleBanner}</span>
              {hayBanner ? <span className='ih-top-banner'>{imagenBanner}</span> : null}
            </div>


          </div>

          <div className="d-flex">

            {hayBanner ? (
              <div className='AdvertisingContainer-Header'>
                {imagenBanner}
              </div>
            ) : null}

            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <Icon name="search" className="icon-lg" />
              </button>
              <div
                className={
                  search
                    ? 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show'
                    : 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0'
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {LoadingHeader ? (
              <div className="Conteiner-ProgressBar-Header">
                <div style={{ width: '92%' }}>
                  <IProgressBar color={primaryColor} border={false} />
                </div>
              </div>
            ) : null}









            {/* <LanguageDropdown /> */}

            {/* light / dark mode */}
            {/* <LightDark
              layoutMode={layoutMode}
              onChangeLayoutMode={props.onChangeLayoutMode}
            /> */}

            {rol != 24 ? (
              <DropdownToggle className="btn header-item noti-icon " tag="button">
                <Link to={'/support'}>
                  <Icon
                    name="help-circle"
                    className="icon-lg"
                    color={primaryColor}
                    {...props}
                  />
                </Link>
              </DropdownToggle>
            ) : null}

            <Dropdown
              className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}
            >
              {/* <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                <div className="p-2">
                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={github} alt="Github" />
                        <span>GitHub</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={bitbucket} alt="bitbucket" />
                        <span>Bitbucket</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dribbble} alt="dribbble" />
                        <span>Dribbble</span>
                      </Link>
                    </Col>
                  </Row>

                  <Row className="g-0">
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={dropbox} alt="dropbox" />
                        <span>Dropbox</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={mail_chimp} alt="mail_chimp" />
                        <span>Mail Chimp</span>
                      </Link>
                    </Col>
                    <Col>
                      <Link className="dropdown-icon-item" to="#">
                        <img src={slack} alt="slack" />
                        <span>Slack</span>
                      </Link>
                    </Col>
                  </Row>
                </div>
              </DropdownMenu> */}
            </Dropdown>

            {/* <NotificationDropdown /> */}
            <ProfileMenu />
          </div>
        </div>
      </header>
      <ReactDrawer open={open} position={position}>
        {/* <RightSidebar
          onClose={onDrawerClose}
          onChangeLayoutMode={props.onChangeLayoutMode}
        /> */}
      </ReactDrawer>
    </React.Fragment>
  );
};

export default Header;
